import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useNoindex } from "./clientApi";

function initials(me) {
  const a = (me?.first_name || "").trim()[0] || "";
  const b = (me?.last_name || "").trim()[0] || "";
  return (a + b).toUpperCase() || "?";
}

export function ClientHeader({ me, onLogout, hasNews }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const [menu, setMenu] = useState(false);
  const onCampaigns = loc.pathname === "/espace-client" || loc.pathname.startsWith("/espace-client/campagnes");
  const onDocuments = loc.pathname.startsWith("/espace-client/documents");
  return (
    <>
      <div className="cp-topbar" />
      <header className="cp-hd" data-testid="cp-header">
        <div className="cp-hd-left">
          <button className="cp-burger" data-testid="cp-burger" aria-label="Menu">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
          </button>
          <span className="cp-logo">SLIZ</span>
          <span className="cp-sep" />
          <nav className="cp-tabs">
            <button className={`cp-tab ${onCampaigns ? "active" : ""}`} onClick={() => navigate("/espace-client")} data-testid="cp-tab-campaigns">Mes campagnes</button>
            <button className={`cp-tab ${onDocuments ? "active" : ""}`} onClick={() => navigate("/espace-client/documents")} data-testid="cp-tab-documents">Documents</button>
            <button className="cp-tab" data-testid="cp-tab-help">Aide</button>
          </nav>
        </div>
        <div className="cp-hd-right">
          <button className="cp-bell" data-testid="cp-bell" aria-label="Notifications">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></svg>
            {hasNews && <span className="dot" />}
          </button>
          <button className="cp-user" onClick={() => setMenu((v) => !v)} data-testid="cp-user">
            <span className="cp-avatar">{initials(me)}</span>
            <span>
              <span className="cp-user-name" style={{ display: "block" }}>{(me?.first_name || "") + " " + (me?.last_name || "")}</span>
              <span className="cp-user-org" style={{ display: "block" }}>{me?.organization_name || ""}</span>
            </span>
          </button>
          {menu && (
            <div className="cp-menu" data-testid="cp-user-menu">
              <button onClick={onLogout} data-testid="cp-logout">Se déconnecter</button>
            </div>
          )}
        </div>
      </header>
    </>
  );
}

export function ClientAuthShell({ children }) {
  useNoindex();
  return (
    <div className="cp-root" data-testid="cp-root">
      <div className="cp-topbar" />
      <div className="cp-center">
        <div style={{ width: "100%", maxWidth: 440 }}>
          <span className="cp-auth-logo">SLIZ</span>
          {children}
        </div>
      </div>
    </div>
  );
}
